<script>
    import {PAYMENT_TYPE, ROUTE_TYPE, SUMMARY_TITLES} from "../lib/js/constants.js";
    import {DMY_HM, hasBoatName, hasFlightNo, formatPrice} from "../lib/js/utils.js";

    export let reservation;
    export let showVehicle = true;
    export let showPrice = true;

    if (reservation.vehicle) {
        reservation.vehicle.price = Number(reservation.vehicle.price);
        reservation.vehicle.start_price = Number(reservation.vehicle.start_price);
    }

    reservation.routes.map(route => {
        if (!route.title) {
            if (route.route_type == ROUTE_TYPE.ARRIVAL) {
                route.title = SUMMARY_TITLES['arrival'];
            } else if (route.route_type == ROUTE_TYPE.DEPARTURE) {
                route.title = SUMMARY_TITLES['departure'];
            } else if (route.route_type == ROUTE_TYPE.TRANSFER) {
                route.title = SUMMARY_TITLES['location'];
            }
        }
    });
</script>

<div class="section-title mb-4">
    <h2 class="h4 mb-0">{reservation.title}</h2>
</div>


{#each reservation.routes as route, index}
    <div class="panel panel-gray p-4 mb-2">
        <div class="d-flex flex-column gap-2">
            {#if route.route_type == ROUTE_TYPE.TOUR}
                <div class="summary-row">
                    <div class="title">
                        {#if reservation.routes.length > 1}
                            {index + 1}.
                        {/if}
                        Private Tour:
                    </div>
                    <div class="data fw-semibold">
                        {route.title}
                    </div>
                </div>
                <div class="summary-row">
                    <div class="title">Pickup:</div>
                    <div class="data">
                        {route._pickup.name}
                    </div>
                </div>
            {:else}
                <div class="summary-row">
                    <div class="title">
                        {#if reservation.routes.length > 1}
                            {index + 1}.
                        {/if}
                        {route.title}:
                    </div>
                    <div class="data fw-semibold">
                        {route._pickup.name} → {route._drop.name}
                    </div>
                </div>
                {#if route._pickup.address}
                    <div class="summary-row">
                        <div class="title">Pickup address:</div>
                        <div class="data">
                            {route._pickup.address}
                        </div>
                    </div>
                {:else if route._drop.address}
                    <div class="summary-row">
                        <div class="title">Destination address:</div>
                        <div class="data">
                            {route._drop.address}
                        </div>
                    </div>
                {/if}
            {/if}
            <div class="summary-row">
                <div class="title">Date & Time:</div>
                <div class="data">
                    {#if route.transfer_at}
                        {DMY_HM(route.transfer_at)}
                    {:else}
                        <span class="text-gray">Exact date arranged after booking</span>
                    {/if}
                </div>
            </div>
            {#if route.flight_no}
                {#if hasFlightNo(route._pickup, route._drop)}
                    <div class="summary-row">
                        <div class="title">Flight no:</div>
                        <div class="data">{route.flight_no}</div>
                    </div>
                {:else if hasBoatName(route._pickup, route._drop)}
                    <div class="summary-row">
                        <div class="title">Ferry</div>
                        <div class="data">{route.flight_no}</div>
                    </div>
                {/if}
            {/if}
        </div>
    </div>
{/each}
<div class="panel panel-gray p-4">
    <div class="d-flex flex-column gap-2">
        <div class="summary-row">
            <div class="title">Passengers:</div>
            <div class="data">
                Adults <span class="times">x</span> {reservation.adults}
                {#if reservation.children > 0}
                    Children <span class="times">x</span> {reservation.children}
                {/if}
                {#if reservation.infants > 0}
                    Infants <span class="times">x</span> {reservation.infants}
                {/if}
            </div>
        </div>
        {#if reservation.booster_seats + reservation.baby_seats + reservation.infant_seats > 0}
            <div class="summary-row">
                <div class="title">Extras:</div>
                <div class="data">
                    {#if reservation.baby_seats > 0}
                        Baby seats <span class="times">x</span> {reservation.baby_seats}
                    {/if}
                    {#if reservation.booster_seats > 0}
                        Boosters <span class="times">x</span> {reservation.booster_seats}
                    {/if}
                    {#if reservation.infant_seats > 0}
                        Infant seats <span class="times">x</span> {reservation.infant_seats}
                    {/if}
                </div>
            </div>
        {/if}
        <div class="summary-row">
            <div class="title">Luggage:</div>
            <div class="data">
                {#if reservation.luggage > 0}
                    <span class="times">x</span> {reservation.luggage}
                {:else}
                    No luggage
                {/if}
            </div>
        </div>
        {#if showVehicle && reservation.vehicle}
            <div class="summary-row">
                <div class="title">Vehicle:</div>
                <div class="data">
                    <div>
                        {reservation.vehicle.name}
                    </div>
                    {#if reservation.vehicle.info}
                        <div class="smaller text-gray">
                            {reservation.vehicle.info}
                        </div>
                    {/if}
                </div>
            </div>
        {/if}
        {#if showPrice}
            <div class="summary-row">
                <div class="title">Total price:</div>
                <div class="data">
                    {#if reservation.price != null}
                        {#if reservation.start_price}
                            <span class="start-price text-muted">
                                <s>{formatPrice(reservation.start_price)}</s>
                            </span>
                        {/if}
                        <span class="fw-semibold">{formatPrice(reservation.price)}</span>
                    {:else}
                        Price on request
                    {/if}
                </div>
            </div>
            {#if reservation.payment_type == PAYMENT_TYPE.CARD}
                <div class="summary-row">
                    <div class="title">Payment method:</div>
                    <div class="data">Debit / Credit Card</div>
                </div>
            {:else if reservation.payment_type == PAYMENT_TYPE.BANK}
                <div class="summary-row">
                    <div class="title">Payment method:</div>
                    <div class="data">Bank deposit</div>
                </div>
            {/if}
        {/if}
    </div>
    <div class="mt-4 small">
        All transfers are private and include complimentary bottled water and Wi-Fi.
    </div>
</div>

<style>
    .summary-row {
        display: flex;
        gap: 20px;
        border-bottom: 1px solid #fff;
        padding-bottom: 0.5rem;
    }

    .summary-row:last-child {
        border: none;
        padding-bottom: 0;
    }

    .summary-row .title {
        width: 140px;
        font-size: 14px;
        font-weight: 500;
        color: #50ba87;
    }

    .summary-row .data {
        flex: 1;
    }

    .start-price {
        font-size: 0.85rem;
        padding-right: 10px;
    }

    @media (max-width: 1199px) {
        .summary-row {
            flex-direction: column;
            gap: 0;
        }

        .summary-row .title {
            width: 100%;
            font-size: 12px;
            font-weight: 600;
        }
    }
</style>